import { Layout } from "antd";
import React, { PropsWithChildren, ReactNode, useState } from "react";
import { useResizable } from "../SpatialConfigurationMode/hooks/useResizable";
import styles from "./DualViewSideDrawer.module.css";
import { DualViewSideDrawerContent } from "./DualViewSideDrawerContent";

const { Content, Sider } = Layout;

type SideDrawerTabProps = PropsWithChildren<{
  spotlightQAContent: ReactNode;
  arrowsContent: ReactNode;
  floorplansContent?: ReactNode;
  onCollapse?: (collapsed: boolean) => void;
}>;

export const LayoutWithSideDrawer = (props: SideDrawerTabProps) => {
  const [collapsed, setCollapsed] = useState(true);
  const { width: drawerWidth, startResize } = useResizable({
    initial: 400,
    min: 280,
    max: 700,
    storageKey: "dual-view-drawer-width",
    anchor: "right",
  });

  return (
    <Layout className={styles.layout}>
      <Content>{props.children}</Content>
      {!collapsed && (
        <div
          role="separator"
          aria-orientation="vertical"
          aria-label="Resize side drawer"
          className={styles["resizer"]}
          onMouseDown={startResize}
        />
      )}
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(isCollapsed) => {
          setCollapsed(isCollapsed);
          props.onCollapse && props.onCollapse(isCollapsed);
        }}
        width={drawerWidth}
        reverseArrow
        theme="light"
      >
        <DualViewSideDrawerContent
          spotlightQAContent={props.spotlightQAContent}
          arrowsContent={props.arrowsContent}
          floorplansContent={props.floorplansContent}
          onClickMenuItem={() => {
            if (collapsed) {
              setCollapsed(false);
              props.onCollapse && props.onCollapse(collapsed);
            }
          }}
          isCollapsed={collapsed}
        />
      </Sider>
    </Layout>
  );
};
